import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";

/**
 * MasterDetailLayout
 * Wrapper para estruturar páginas Master-Detail com consistência.
 */
const MasterDetailLayout = ({ master, detail }) => {
    return (
        <Row className="g-4">
            {/* LADO ESQUERDO: LISTA / SELEÇÃO */}
            <Col lg={3} md={4}>
                {master}
            </Col>

            {/* LADO DIREITO: EDITOR / DETALHES */}
            <Col lg={9} md={8}>
                {detail}
            </Col>
        </Row>
    );
};

MasterDetailLayout.propTypes = {
    master: PropTypes.node.isRequired,
    detail: PropTypes.node.isRequired
};

export default MasterDetailLayout;
